/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { PortfolioWorkListAdmin } from './PortfolioWorkListAdmin'
import {
  PortfolioWorkListAdminFromJSON,
  PortfolioWorkListAdminFromJSONTyped,
  PortfolioWorkListAdminToJSON,
} from './PortfolioWorkListAdmin'

/**
 *
 * @export
 * @interface PaginatedPortfolioWorkListAdmin
 */
export interface PaginatedPortfolioWorkListAdmin {
  /**
   *
   * @type {Array<PortfolioWorkListAdmin>}
   * @memberof PaginatedPortfolioWorkListAdmin
   */
  results: Array<PortfolioWorkListAdmin>
  /**
   *
   * @type {number}
   * @memberof PaginatedPortfolioWorkListAdmin
   */
  count: number
  /**
   *
   * @type {string}
   * @memberof PaginatedPortfolioWorkListAdmin
   */
  next: string | null
  /**
   *
   * @type {string}
   * @memberof PaginatedPortfolioWorkListAdmin
   */
  previous: string | null
}

/**
 * Check if a given object implements the PaginatedPortfolioWorkListAdmin interface.
 */
export function instanceOfPaginatedPortfolioWorkListAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'results' in value
  isInstance = isInstance && 'count' in value
  isInstance = isInstance && 'next' in value
  isInstance = isInstance && 'previous' in value

  return isInstance
}

export function PaginatedPortfolioWorkListAdminFromJSON(
  json: any,
): PaginatedPortfolioWorkListAdmin {
  return PaginatedPortfolioWorkListAdminFromJSONTyped(json, false)
}

export function PaginatedPortfolioWorkListAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedPortfolioWorkListAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    results: (json['results'] as Array<any>).map(PortfolioWorkListAdminFromJSON),
    count: json['count'],
    next: json['next'],
    previous: json['previous'],
  }
}

export function PaginatedPortfolioWorkListAdminToJSON(
  value?: PaginatedPortfolioWorkListAdmin | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    results: (value.results as Array<any>).map(PortfolioWorkListAdminToJSON),
    count: value.count,
    next: value.next,
    previous: value.previous,
  }
}
